module.exports = __webpack_public_path__ + "924f15b06f28f7c5dfc4532d45c2be67.png";